import { render } from "./PrimaryCareModuleSettingsOverlay.vue?vue&type=template&id=6f8e8da0&scoped=true&lang=pug"
import script from "./PrimaryCareModuleSettingsOverlay.vue?vue&type=script&lang=js"
export * from "./PrimaryCareModuleSettingsOverlay.vue?vue&type=script&lang=js"

import "./PrimaryCareModuleSettingsOverlay.vue?vue&type=style&index=0&id=6f8e8da0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8e8da0"]])

export default __exports__